// src/utils/logger.js
const isDevelopment = process.env.NODE_ENV === "development";

export const logger = {
  log: isDevelopment ? console.log : () => {},
  info: isDevelopment ? console.info : () => {},
  debug: isDevelopment ? console.debug : () => {},
  warn: isDevelopment ? console.warn : () => {},

  // Always show errors, even in production
  error: console.error,
};

// Alternative: Simple function export
export const log = isDevelopment ? console.log : () => {};
export const warn = isDevelopment ? console.warn : () => {};
export const error = console.error; // Always show errors
